import { render, staticRenderFns } from "./ActCreate.vue?vue&type=template&id=c4e4597a&"
import script from "./ActCreate.vue?vue&type=script&lang=js&"
export * from "./ActCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports